// extracted by mini-css-extract-plugin
module.exports =  {"attachments-list-wrapper":"EBVMGIG","attachmentsListWrapper":"EBVMGIG","label":"phT14zU","attachments-list":"orAMMLv","attachmentsList":"orAMMLv","item":"PzZgvdo"};